export const NativeBridgeEvents = {
  SESSION_REFRESHED: 'session:refreshed',
  AUTH_REQUIRED: 'auth:required',
  SIGN_OUT: 'sign:out',
} as const

export type SessionRefreshedMessage = {
  type: typeof NativeBridgeEvents.SESSION_REFRESHED
  callbackUrl: string
}

export type AuthRequiredMessage = {
  type: typeof NativeBridgeEvents.AUTH_REQUIRED
  callbackUrl: string
}

export type SignOutMessage = {
  type: typeof NativeBridgeEvents.SIGN_OUT
}

export type NativeBridgeMessage = SessionRefreshedMessage | AuthRequiredMessage | SignOutMessage
